'use strict';

var Sugar = require('sugar-core'),
    stringUnderscore = require('./internal/stringUnderscore');

Sugar.String.defineInstance({

  'underscore': function(str) {
    return stringUnderscore(str);
  }

});

module.exports = Sugar.String.underscore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/underscore.js
// module id = 936
// module chunks = 0